export const translations = {
	'All day': { no: 'Full dag' },
};
